import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { formatDate } from "../../../utils/date";
import { formatNumberWithCommas } from "../../../utils/numbers";
import { getErrorCodeSummary } from "../../../utils/errorCodes";

type Reading = {
  deviceTime: string;
  totalVolume: number;
  errorCode?: number;
  battery?: number;
};

type GenerateProps = {
  meterSerialNo: string;
  readings: Reading[];
  showLiters: boolean;
};

function formatVolume(value: number | null | undefined, showLiters: boolean): string {
  if (value === null || value === undefined) return "--";
  if (showLiters) return formatNumberWithCommas(Math.round(value));
  const truncated = Math.trunc(value / 10) / 100;
  return formatNumberWithCommas(truncated);
}

export default function generateSharedReadingsPdf({ meterSerialNo, readings, showLiters }: GenerateProps) {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const unitLabel = showLiters ? "(l)" : "(units)";

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Meter Readings Report", pageWidth - 14, 12, { align: "right" });

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  const labelText = "Meter No.: ";
  const labelWidth = doc.getTextWidth(labelText);
  const fullLineWidth = doc.getTextWidth(`Meter No.: ${meterSerialNo}`);
  const lineStartX = pageWidth - 14 - fullLineWidth;
  doc.setTextColor(0, 0, 0);
  doc.text(labelText, lineStartX, 20);
  doc.setTextColor(220, 0, 0);
  doc.text(meterSerialNo, lineStartX + labelWidth, 20);
  doc.setTextColor(0, 0, 0);

  const body = readings.map((row) => {
    const alarmSummary = getErrorCodeSummary(row.errorCode || 0);
    return [
      formatDate(row.deviceTime),
      formatVolume(row.totalVolume, showLiters),
      alarmSummary === "No Errors" ? "None" : alarmSummary,
      row.battery !== undefined && row.battery !== null ? `${row.battery}%` : "--",
    ];
  });

  autoTable(doc, {
    head: [[
      "Date & Time",
      `Volume ${unitLabel}`,
      "Alarms",
      "Battery",
    ]],
    body,
    startY: 25,
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: [0, 0, 0],
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      lineWidth: 0.3,
      lineColor: [0, 0, 0],
    },
  });

  doc.save(`readings-report-${meterSerialNo}.pdf`);
}
